export default __webpack_public_path__ + "static/media/portfolio-150.b732d110.jpg";